import setupCustomerBundle from "app/scripts/setup_customer_bundle"

import "stylesheets/customer.scss"

setupCustomerBundle()
